export default __webpack_public_path__ + "static/media/army_33.3a61bf41.jpg";